import * as React from "react";
import PropTypes from "prop-types";
import AppContainerBreakpointProvider from "nx-components/AppContainerBreakpointProvider";

import { StaticSizedArea } from "nexia_mobile/components/Page";

const AppBarWrapper = ({ children }) => (
  <StaticSizedArea>
    <AppContainerBreakpointProvider>{children}</AppContainerBreakpointProvider>
  </StaticSizedArea>
);

AppBarWrapper.propTypes = {
  children: PropTypes.node,
};

export default AppBarWrapper;



// WEBPACK FOOTER //
// ./src/components/TopBar/AppBarWrapper.jsx